// extracted by mini-css-extract-plugin
export default {"ratingContainer":"RatingStars_ratingContainer__pkVOD","star":"RatingStars_star__rRYuE"};